// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__14qyO","footer":"ModalError_footer__8S2vg"};